/**
 * EmptyState — placeholder cuando no hay data.
 *
 * Uso:
 *   <EmptyState
 *     label="Pedidos"
 *     title="Sin tareas todavía"
 *     description="Tu agencia está armando el plan. Te avisamos cuando esté."
 *     action={<button onClick={…}>Refrescar</button>}
 *   />
 *
 * v8.5.49 · piel · sin ilustraciones ni emoji — `icon` (que casi toda
 * pantalla sigue pasando como "🎉"/"📭") queda aceptado pero ya no se
 * renderiza, así ningún call-site rompe por seguir mandándolo. `label` es
 * nuevo: el rótulo mono uppercase que reemplaza al emoji como ancla visual.
 * El estilo del botón de `action` lo define quien llama — este componente
 * solo garantiza la regla "como máximo una acción" al aceptar un slot único.
 */

export default function EmptyState({
  label,
  title,
  description,
  action,
  size = "default", // 'sm' | 'default' | 'lg'
  className = "",
}) {
  const sizes = {
    sm:      { wrap: "py-6",  titleCls: "text-[20px]" },
    default: { wrap: "py-10", titleCls: "text-[24px]" },
    lg:      { wrap: "py-14", titleCls: "text-[28px]" },
  };
  const s = sizes[size] || sizes.default;
  return (
    <div className={`text-center max-w-prose mx-auto ${s.wrap} px-6 ${className}`}>
      {label && (
        <div className="font-mono text-[12px] font-medium uppercase tracking-[.08em] text-[var(--muted)] mb-2">
          {label}
        </div>
      )}
      <h3 className={`font-display ${s.titleCls} text-[var(--ink)]`}>{title}</h3>
      {description && (
        <p className="text-[15px] text-[var(--ink-3)] mt-1.5 leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
